import { render, staticRenderFns } from "./TopConnections.vue?vue&type=template&id=2b8f7282&scoped=true"
import script from "./TopConnections.vue?vue&type=script&lang=js"
export * from "./TopConnections.vue?vue&type=script&lang=js"
import style0 from "./TopConnections.vue?vue&type=style&index=0&id=2b8f7282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8f7282",
  null
  
)

export default component.exports